import { render, staticRenderFns } from "./CloneConfirmationPopup.vue?vue&type=template&id=21a60576&scoped=true&"
import script from "./CloneConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./CloneConfirmationPopup.vue?vue&type=script&lang=js&"
import style0 from "./CloneConfirmationPopup.vue?vue&type=style&index=0&id=21a60576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a60576",
  null
  
)

export default component.exports